import type {
	CreateExporterPayload,
	CreateExporterResponse,
	Exporter,
	StatusResponse,
	UpdateExporterPayload,
} from '../exportersApi'
import { demoApi } from './db'

export const exportersApi = {
	getExporters: async (_page?: number, _perPage?: number): Promise<{ count?: number; data: Exporter[] }> =>
		//TODO: implement pagination for exporters in demo
		demoApi.get('/v3/exporters'),

	getExporter: async (id: string): Promise<Exporter> => demoApi.get(`/v3/exporters/${encodeURIComponent(id)}`),

	createExporter: async (payload: CreateExporterPayload): Promise<CreateExporterResponse> =>
		demoApi.post('/v3/exporters', payload),

	updateExporter: async (id: string, payload: UpdateExporterPayload): Promise<StatusResponse> =>
		demoApi.patch(`/v3/exporters/${encodeURIComponent(id)}`, payload),

	deleteExporter: async (id: string): Promise<StatusResponse> =>
		demoApi.delete(`/v3/exporters/${encodeURIComponent(id)}`),
}
